import Pristine from 'pristinejs';

let enquiryForm;
let pristine;

const init = () => {
  const enquiryTypeSelectEl = document.getElementById('enquiry-type-select');
  if (!!enquiryTypeSelectEl) {
    enquiryTypeSelectEl.addEventListener('change', changeEnquiryType);
  }

  enquiryForm = document.getElementById('enquiry-form');

  if (!!enquiryForm) {
    setupEnquiryForm();
  }
};

function setupEnquiryForm() {
  clearRequiredEls();

  enquiryForm.addEventListener('submit', (e) => {
    e.preventDefault();
    pristine = new Pristine(enquiryForm);
    const isValid = pristine.validate();

    if (!isValid) {
      console.log(pristine.getErrors(), 'form is NOT valid');
      return;
    }
    // send form
    sendEnquiry();
  });
}

function sendEnquiry() {
  // Collect the form data while iterating over the inputs
  const data = {};
  for (let i = 0, ii = enquiryForm.length; i < ii; ++i) {
    const input = enquiryForm[i];
    if (input.name && !input.disabled) {
      data[input.name] = input.value;
    }
  }

  const formData = new FormData(enquiryForm);

  // Construct an HTTP request
  const xhr = new XMLHttpRequest();
  xhr.open(enquiryForm.method, '/', true);
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

  // Send the collected data as encoded form data
  xhr.send(new URLSearchParams(formData).toString());

  // Callback function
  xhr.onloadend = (response) => {
    switch (response.target.status) {
      case 200:
        document.getElementById('enquiry-btn')
            .classList.add('is-hidden');
        document.getElementById('enquiry-success-message')
            .classList.remove('is-hidden');
        break;
      default:
        console.log('unknown status', response);
        break;
    }
  };
}

function clearRequiredEls() {
  const weddingRequiredEls = document
      .querySelectorAll('.js-wedding-required');
  const standardRequiredEls = document
      .querySelectorAll('.js-standard-required');
  weddingRequiredEls.forEach(clearValidation);
  standardRequiredEls.forEach(clearValidation);
}

function clearValidation(el) {
  el.setAttribute('disabled', '');
  el.setAttribute('required', '');
  el.disabled = true;
  el.required = false;
}

function addValidation(el) {
  el.setAttribute('disabled', '');
  el.setAttribute('required', '');
  el.disabled = false;
  el.required = true;
}

function changeEnquiryType(event) {
  const typeIndex = event.target.selectedIndex;
  const weddingEl = document.getElementById('enquiry-wedding');
  const standardEl = document.getElementById('enquiry-standard');

  clearRequiredEls();

  const weddingRequiredEls = document
      .querySelectorAll('.js-wedding-required');
  const standardRequiredEls = document
      .querySelectorAll('.js-standard-required');

  // add hidden class to all
  weddingEl.classList.add('is-hidden');
  standardEl.classList.add('is-hidden');

  // Assumption: wedding is always second in the dropdown list
  if (typeIndex === 2) {
    weddingRequiredEls.forEach(addValidation);
    return weddingEl.classList.remove('is-hidden');
  }

  standardRequiredEls.forEach(addValidation);
  // default to standard enquiry
  return standardEl.classList.remove('is-hidden');
}

export default {init};
